// Shared brand constants for the two restaurants
export const WHATSAPP_NUMBER = "351917240397";
export const WHATSAPP_DISPLAY = "917 240 397";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const TARQ = {
  key: "tarquinio",
  name: "Tarquínio Beach Club",
  short: "Tarquínio",
  foundedYear: 1929,
  address: "Muralha da Praia, Apoio 14, 2825-382 Costa da Caparica",
  hours: [
    { days: "Todos os dias", time: "09:00 — 23:00" },
  ],
  instagram: "https://www.instagram.com/tarquinio_beach/",
  facebook:
    "https://www.facebook.com/p/Tarqu%C3%ADnio-Beach-Club-100048491577217/",
  mapsQuery:
    "https://www.google.com/maps?q=Muralha+da+Praia+Apoio+14+Costa+da+Caparica&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Muralha+da+Praia+Apoio+14+Costa+da+Caparica",
  // True-transparent processed PNG (white bg removed via alpha)
  logo: "/tarq-logo.png",
  gatewayLogo: "/tarq-logo.png",
};

export const BBQ = {
  key: "bbq",
  name: "BBQ Assador",
  subtitle: "Casa de Petiscos",
  short: "BBQ",
  address: "Av. Gen. Humberto Delgado 31 D, 2825-343 Costa da Caparica",
  hours: [{ days: "Todos os dias", time: "10:00 — 22:00" }],
  mapsQuery:
    "https://www.google.com/maps?q=Avenida+General+Humberto+Delgado+31+D+Costa+da+Caparica&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Avenida+General+Humberto+Delgado+31+D+Costa+da+Caparica",
  logo:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/i2qxk31w_BBQ%20LOGO.png",
  gatewayLogo:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/hromu8ol_5205.png",
};

/* ============ TARQ REAL PHOTOS — new premium batch ============ */
const TARQ_PHOTOS = {
  // Premium exterior facade at sunset with TARQUINIO lettering
  exteriorSunset:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/ebk4w9my_16FB924B-8A46-4E29-9EFD-C63DB9FA56E2.png",
  // Premium golden-hour interior with hanging boat, GELADOS sign, terrace floor
  interiorGolden:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/ot02g7kg_69F07900-9070-4243-800E-A7FD9072B32D.png",
  // Beach sunset with Tarquinio Beach Club sign + flag + sun setting
  sunsetSign:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/vf4wxlaf_C7BA0CA1-EE86-4C1C-B74C-AA3083477B23.png",
  // Watermelon cocktails on bar
  cocktails:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/54p1718x_959410CE-2ABF-4167-A283-5874BC3B8029.png",
  // Historical 1929 — fishermen family in front of Tarquinio shed
  history1929:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/jcco5a2h_1232FA25-9935-485C-85D0-30DDB64C808C.png",
  // Historical 1999 — Tarquinio Bar wooden building with flags
  history1999:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/54t33vxa_16D32A98-E6D2-46B7-8431-55CDAAAE6F3F.png",
  // Legacy fallback (entrance bridge)
  entrance:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/saq29rzq_praia-do-tarquinio-paraiso-2.jpg",
};
// Backwards-compatible aliases for legacy keys still referenced in pages
TARQ_PHOTOS.interior = TARQ_PHOTOS.interiorGolden;
TARQ_PHOTOS.nightExterior = TARQ_PHOTOS.exteriorSunset;

/* ============ BBQ REAL PHOTOS — new premium batch ============ */
const BBQ_PHOTOS = {
  // Premium golden-hour exterior with ASSADOR BBQ sign + esplanada
  exterior:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/pzw25jvt_C0E07637-9941-4238-8449-BD2EADC88DBE.png",
  // Warm wooden interior bar (Sagres barrels, Coca-Cola signs, log ceiling)
  interior:
    "https://customer-assets.emergentagent.com/job_two-tables-one-coast/artifacts/g3iwj1up_4B99F0A1-FAAC-4F5D-A367-E14B0A6AE375.png",
};

export const IMAGES = {
  // Gateway
  gatewayLeft: TARQ_PHOTOS.exteriorSunset,
  gatewayRight: BBQ_PHOTOS.exterior,

  // Tarquinio — new premium photos
  tarqHero: TARQ_PHOTOS.exteriorSunset,
  tarqFeature: TARQ_PHOTOS.interiorGolden,
  tarqSunset: TARQ_PHOTOS.sunsetSign,
  tarqPhotos: TARQ_PHOTOS,

  // BBQ — new premium photos
  bbqPhotos: BBQ_PHOTOS,
  bbqHero: BBQ_PHOTOS.exterior,
  bbqExterior: BBQ_PHOTOS.exterior,
  bbqInterior: BBQ_PHOTOS.interior,
};
